export const GRID_MINIMAL_GRANULARITY_IN_MINUTES = 5
export const ONE_HOUR_IN_MINUTES = 60
export const HALF_HOUR_IN_MINUTES = 30
export const ROUND_HEADCOUNT_CLOSER_DECIMAL = 0.25
